export enum FormFieldOnInitPropertyEnum {
    COMPONENT = 'component',
    CONSTRAINT_NAME = 'constraintNames',
    DISPLAY_FORMAT_VALUES = 'displayFormatValues',
    FORM_FIELD = 'formField', // Note:  this is currently provided, but every form ...
                              //        field also has a public 'formField' property ...
                              //        that has the its FormField instance.
    IS_FOOTNOTE = 'isFootnote', // Indicates that this form field is a footnote form field,
                                // a type of annotation to another form field.
    PROPERTIES = 'properties', // This form field onInit() property contains an array of values,
                               // each of which should be defined in enum FormFieldPropertyEnum.
    SAVE_CONFIGURATION_REQUIRED = 'saveConfigurationRequired', // If a form field component passes a
                                                               // value of true for this property, that
                                                               // component requires a call to package
                                                               // its configuration data prior to a
                                                               // form definition save with the form builder.
    SAVE_DATA_REQUIRED = 'saveDataRequired', // Indicates that the form field component requires
                                             // a call to it saveData() method prior to saving
                                             // a form instance.
    PROPERTY_UPDATE_REQUIRES = 'propertyUpdateRequired' // Indicates that a form field component
                                                        // requires a call to its propertyUpdated()
                                                        // method whenever a property is updated in
                                                        // the form field property configuration
                                                        // drawer/panel.
}
